/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from 'react';
import { Button, Form, Row, Col, OverlayTrigger, Tooltip } from "react-bootstrap";
import CategoriesApi from "../../../api/categoriesApi";
import projectApi from "../../../api/projectApi";
import { toast } from 'react-toastify';
import Helpers from "../../../components/Helpers";
import CustomDataTable from '../../../components/CustomDataTabe';
import DeleteModel from "../../../components/DeleteModel";
import CreateProjectModel from "../../../components/CreateProjectModel";
import ProjectContext from '../../../context/projectContext';

const Categories = () => {
    const { projectId, updateProject } = useContext(ProjectContext);
    const { projectDetails, updateProjectDetails } = useContext(ProjectContext);
    const [rows, setRows] = useState([]);
    const [LoadData, setLoadData] = useState(false);
    const [showDeleteCatModal, setShowDeleteCatModal] = useState(false);
    const [categoryId, setCategoryId] = useState("");
    const [validated, setValidated] = useState(false);
    const [categoryColor, setCategoryColor] = useState("");
    const [showProjectModal, setShowProjectModal] = useState(false);
    const [showDeleteProjectModal, setShowDeleteProjectModal] = useState(false);
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);

    const handleCloseCatModal = () => setShowDeleteCatModal(false);

    const renderTooltip = (props) => (
        <Tooltip id="button-tooltip">{props}</Tooltip>
    );

    const [data, setData] = useState({
        categoryId: "",
        category1: "",
        categoryColor: "#dfe5eb",
        durationFrom: 1,
        durationTo: 2
    });

    useEffect(() => {
        getProjectDetails();
        getList();
    }, [projectId]);

    const getProjectDetails = async () => {
        const Api = new projectApi();
        if (projectId !== null && projectId !== "") {
            let result = await Api.getProjectDetails(projectId);
            if (result) {
                setProjectData(result);
                updateProjectDetails(result);
            }
        }
    };

    const getList = async () => {
        setLoadData(true)
        const Api = new CategoriesApi();
        await Api.getAllCategories(projectId).then(async (response) => {
            if (response && response.length) {
                setRows(response)
                setLoadData(false)
            } else {
                setLoadData(false)
                setRows([])
            }
        }).catch((error) => {
            toast.error(error.toString());
        });
    }

    const handleChange = (e) => {
        let { name, value } = e.target;

        // Ensure that duration fields are numbers
        if (name === 'durationFrom' || name === 'durationTo') {
            value = parseFloat(value);
        }

        if (name === 'categoryColor') {
            setCategoryColor(value);
        }

        setData({
            ...data,
            [name]: value
        });
    };

    const handleSubmit = async (e) => {
        const form = e.currentTarget;
        e.preventDefault();

        if (!isButtonDisabled) {
            if (form.checkValidity() === false) {
                e.stopPropagation();
                setValidated(true);
                return;
            }

            // Additional custom validation
            if (data.durationFrom < 1) {
                toast.error("Duration From must be at least 1.");
                return;
            }
            if (data.durationTo < 2) {
                toast.error("Duration To must be at least 2.");
                return;
            }

            setIsButtonDisabled(true); // Disable button
            const Api = new CategoriesApi();

            try {
                if (data.categoryId && data.categoryId !== "") {
                    // Edit category
                    const updatedData = { ...data, projectId };
                    await Api.editCategory(data.categoryId, updatedData);
                    toast.success("Category updated successfully.");
                    clearfield();
                } else {
                    // Add category
                    const newData = { ...data, projectId };
                    delete newData.categoryId;
                    await Api.addCategory(newData);
                    toast.success("Category added successfully.");
                    clearfield(); // Clear fields after adding
                }
                setValidated(false);
                getList();
            } catch (error) {
                toast.error("An error occurred while saving the category.");
            } finally {
                setIsButtonDisabled(false); // Re-enable button
            }
        }
    };

    const clearfield = () => {
        setData({
            categoryId: "",
            category1: "",
            categoryColor: "#dfe5eb",
            durationFrom: 1,
            durationTo: 2
        });
        setCategoryId("");
    };

    const CollectData = (item) => {
        setCategoryId(item.categoryId)
        setData({
            categoryId: item.categoryId,
            category1: item.category1,
            categoryColor: item.categoryColor,
            durationFrom: item.durationFrom || 1,
            durationTo: item.durationTo || 2
        })
    }

    const DeleteCatData = async () => {
        const Api = new CategoriesApi();
        clearfield();
        try {
            const response = await Api.deleteCategory(categoryId);
            if (response === undefined) {
                toast.error("This category will not be deleted, blocks are added for it.");
            } else {
                getList();
                setShowDeleteCatModal(false)
                setCategoryId("")
                toast.success("Deleted successfully.");
            }
        } catch (error) {
            setShowDeleteCatModal(false)
            setCategoryId("")
            toast.error("Something went wrong.");
        }
    };

    const handleShowDeleteCatModal = (id) => {
        setShowDeleteCatModal(true);
        setCategoryId(id)
    }

    const columns = [
        {
            id: 1,
            name: 'Categories',
            selector: row => row.category1,
            cell: (row) => (
                <OverlayTrigger
                    placement="right"
                    delay={{ show: 250, hide: 400 }}
                    overlay={renderTooltip(row.category1)}
                >
                    <span>{row.category1}</span>
                </OverlayTrigger>
            ),
            sortable: true,
            reorder: true,
            tag: "allowRowEvents",
            style: {
                cursor: "text"
            }
        },
        {
            id: 2,
            name: 'Color',
            selector: row => row.categoryColor,
            cell: (row) => (
                <div
                    style={{
                        backgroundColor: row.categoryColor,
                        width: "20px",
                        height: "20px",
                        borderRadius: "50%",
                    }}
                />
            ),
            sortable: true,
            style: {
                cursor: "text"
            }
        },
        {
            id: 3,
            name: 'Duration From',
            selector: row => row.durationFrom,
            sortable: true,
            style: {
                cursor: "text"
            }
        },
        {
            id: 4,
            name: 'Duration To',
            selector: row => row.durationTo,
            sortable: true,
            style: {
                cursor: "text"
            }
        },
        {
            id: 5,
            name: 'Created',
            selector: row =>
                Helpers.convertUtcToTimezone(row.createdDate),
            cell: (row) => (
                <OverlayTrigger
                    placement="bottom"
                    delay={{ show: 250, hide: 400 }}
                    overlay={renderTooltip(Helpers.convertUtcToTimezone(row.createdDate, 'MM-DD-YYYY hh:mm:a'))}
                >
                    <span>{row.createdDate ? Helpers.convertUtcToTimezone(row.createdDate, 'MM-DD-YYYY') : ""}</span>
                </OverlayTrigger>
            ),
            sortable: true,
            style: {
                cursor: "text"
            }
        },
        {
            id: 6,
            name: 'Action',
            button: true,
            cell: row => (
                <>
                    {/* <i className="icon-note text-success" onClick={() => CollectData(row)}></i> */}
                    <button
                        onClick={() => CollectData(row)}
                        className="btn-icon"
                        style={{ background: 'none', border: 'none', padding: 0, margin: 0, cursor: 'pointer' }}
                    >
                        <i className="icon-note text-success"></i>
                    </button>

                    {/* <i onClick={() => handleShowDeleteCatModal(row.categoryId)} className="ml-4 icon-trash text-danger"></i> */}
                    <button
                        onClick={() => handleShowDeleteCatModal(row.categoryId)}
                        className="ml-4 text-danger"
                        style={{ background: 'none', border: 'none', padding: 0, margin: 0, cursor: 'pointer' }}
                        aria-label="Delete category"
                    >
                        <i className="icon-trash"></i>
                    </button>
                </>
            )
        }
    ];

    const handleShowProjectModal = () => {
        setShowProjectModal(true);
    };

    const handleShowProjectDeleteModal = () => {
        setShowProjectModal(false)
        setShowDeleteProjectModal(true);
    }

    const handleCloseProjectModal = () => {
        setShowProjectModal(false);
        clearProjectData();
    };

    const handleCloseProjectDeleteModal = () => {
        setShowProjectModal(false);
        clearProjectData();
    };

    const [projectData, setProjectData] = useState({
        projectId: "",
        projectName: "",
        clientName: "",
        description: ""
    });

    const clearProjectData = () => {
        setProjectData({
            projectId: "",
            projectName: "",
            clientName: "",
            description: ""
        });
    };

    const handleProjectChanges = (e) => {
        let { name, value } = e.target;
        setProjectData({
            ...projectData,
            [name]: value
        });
    };

    const saveProjectData = async (e) => {
        e.preventDefault()
        const Api = new projectApi();
        const response = await Api.getAllProjects();
        const projectNameExists = response.some(item => item.projectName === projectData.projectName);
        if (projectData.projectName === "") {
            toast.error("Project name is Required!")
        } else {
            if (projectNameExists) {
                toast.error("Project name already exists!")
            } else {
                // create project
                const newProjectData = { ...projectData };
                delete newProjectData.projectId;
                await Api.addProject(newProjectData).then(async (response) => {
                    if (response) {
                        setProjectData(response);
                        toast.success("Project created successfully.")
                        updateProject(response.projectId)
                        sessionStorage.setItem("projectId", response.projectId)
                        setShowProjectModal(false);
                        clearProjectData();
                    } else {
                        toast.error("Something went wrong.")
                    }
                })
            }
        }
    };

    const deleteProject = async () => {
        const Api = new projectApi();
        try {
            const response = await Api.deleteProject(projectId);
            if (response === undefined) {
                toast.error("Please clear the data before deleting the project.");
                setShowDeleteProjectModal(false)
            } else {
                setShowDeleteProjectModal(false)
                toast.success("Deleted successfully.");
                clearProjectData();
                updateProject(null);
                sessionStorage.removeItem('projectId')
            }
        } catch (error) {
            setShowDeleteProjectModal(false);
            toast.error("Something went wrong.");
        }
    };

    return (
        <>
            {projectId === "" || projectId === null
                ?
                <div className="container-fluid page-body-wrapper">
                    <div className="main-panel">
                        <div className="content-wrapper pt-4">
                            <div className="row purchace-popup">
                                <div className="col-12 stretch-card grid-margin">
                                    <div className="card card-secondary">
                                        <span className="card-body text-center">
                                        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
                                            <span style={{ color: '#007bff', cursor: 'pointer' }} onClick={handleShowProjectModal}>Add New Project</span>
                                            <p className="mb-lg-0">Or</p>
                                            <p className="mb-lg-0">Select Project to continue.</p>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* add/update project modal */}
                    <CreateProjectModel
                        show={showProjectModal}
                        handleClose={handleCloseProjectModal}
                        saveProjectData={saveProjectData}
                        data={projectData}
                        handleChanges={handleProjectChanges}
                        handleShowDeleteModal={handleShowProjectDeleteModal}
                    ></CreateProjectModel>

                    {/* delete project modal */}
                    <DeleteModel
                        show={showDeleteProjectModal}
                        handleClose={handleCloseProjectDeleteModal}
                        DeleteData={deleteProject}
                    ></DeleteModel>
                </div>
                :
                <div className="container-fluid page-body-wrapper">
                    <div className="main-panel">
                        <div className="content-wrapper pt-4">
                            <div className="row purchace-popup">
                                <div className="col-12 stretch-card grid-margin">
                                    <div className="card card-secondary">
                                        <span className="card-body d-lg-flex align-items-center py-2">
                                            {projectDetails && projectDetails.clientName && projectDetails.description ?
                                                <p className="mb-lg-0 clientDetails"> <b className='clientDetails'>{projectDetails.clientName} </b> - {projectDetails.description}</p>
                                                :
                                                <p className="mb-lg-0 clientDetails"> <b className='clientDetails'>{projectDetails.projectName} </b></p>
                                            }
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 grid-margin addCat">
                                    <div className="card">
                                        <div className="card-body">
                                            <h4 className="card-title">Add Category</h4>
                                            <Form onSubmit={handleSubmit} noValidate validated={validated}>
                                                <Row className="align-items-end">
                                                    <Col md={2} sm={6} xs={12}>
                                                        <Form.Group>
                                                            <Form.Label>Category Name</Form.Label>
                                                            <Form.Control
                                                                required
                                                                type="text"
                                                                name="category1"
                                                                placeholder="Enter Category Name"
                                                                value={data.category1}
                                                                onChange={handleChange}
                                                            />
                                                            <Form.Control.Feedback type="invalid">
                                                                Category Name is Required!
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={2} sm={6} xs={12}>
                                                        <Form.Group>
                                                            <Form.Label>Duration From</Form.Label>
                                                            <Form.Control
                                                                required
                                                                type="number"
                                                                name="durationFrom"
                                                                placeholder="From"
                                                                min="1"
                                                                step="0.01"
                                                                value={data.durationFrom}
                                                                onChange={handleChange}
                                                            />
                                                            <Form.Control.Feedback type="invalid">
                                                                Minimum value is 1.
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={2} sm={6} xs={12}>
                                                        <Form.Group>
                                                            <Form.Label>Duration To</Form.Label>
                                                            <Form.Control
                                                                required
                                                                type="number"
                                                                name="durationTo"
                                                                placeholder="To"
                                                                min="2"
                                                                step="0.01"
                                                                value={data.durationTo}
                                                                onChange={handleChange}
                                                            />
                                                            <Form.Control.Feedback type="invalid">
                                                                Minimum value is 2.
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={2} sm={6} xs={12}>
                                                        <Form.Group>
                                                            <Form.Label>Category Color</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="categoryColor"
                                                                placeholder="Select Color"
                                                                value={data.categoryColor || categoryColor || '#dfe5eb'}
                                                                onChange={handleChange}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={1} sm={6} xs={12}>
                                                        <Form.Group>
                                                            <Form.Label>Choose Color</Form.Label>
                                                            <Form.Control
                                                                type="color"
                                                                name="categoryColor"
                                                                value={data.categoryColor || categoryColor || "#dfe5eb"}
                                                                onChange={handleChange}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={2} sm={6} xs={12}>
                                                        <Form.Group>
                                                            <Button className="catBtn" type="submit" variant="success" style={{ width: '100%' }} disabled={isButtonDisabled}>
                                                                {categoryId && categoryId !== "" ? "Update" : "Add"}
                                                            </Button>
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                            </Form>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12 grid-margin stretch-card">
                                    <div className="card">
                                        <div className="card-body categoryTitle">
                                            <div className="d-sm-flex align-items-baseline report-summary-header mb-3">
                                                <h5 className="font-weight-semibold ">Categories</h5>
                                            </div>
                                            <div className="col-lg-12 grid-margin stretch-card">
                                                <div className="card">
                                                    <div className="card-body category">
                                                        <CustomDataTable
                                                            loading={LoadData}
                                                            data={rows}
                                                            columns={columns}
                                                            pointerOnHover={true}
                                                            highlightOnHover={true}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* delete category */}
                    <DeleteModel show={showDeleteCatModal} handleClose={handleCloseCatModal} DeleteData={DeleteCatData}></DeleteModel>
                </div>
            }
        </>
    );
};

export default Categories;